module.exports = __webpack_public_path__ + "static/img/ad4.7ff63648.png";